export const locale = {
  lang: 'vn',
  data: {
    ERROR: {
      HTTP: {
        MAINTENANCE: {
          'TITLE': 'Hệ thống được bảo trì từ {{fromTime}} ngày {{fromDate}} đến {{toTime}} ngày {{toDate}}',
          'MESSAGE': 'Hệ thống đang được bảo trì để sửa lỗi và cập nhật các tính năng mới nhằm nâng cao chất lượng và trải nghiệm người dùng. Chúng tôi rất tiếc vì sự bất tiện này!'
        }
      },
    },
  },
};
